import { yup } from '@framework/validation';

export interface ITableSaveDirective {
  /**
   * Nome del campo da utilizzare per il salvataggio del valore in tabella
   */
  name?: string | null;
}

export const TableSaveDirectiveSchema: yup.ObjectSchema<ITableSaveDirective> =
  yup
    .object({
      name: yup.string().notRequired().label('Nome campo tabella'),
    })
    .noUnknown();
